import React from "react";
import { useLocation, Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "../../context/AppContext";
import { Logo } from "./Logo";

const Splash = () => (
  <div className="min-h-screen flex flex-col items-center justify-center" style={{ background: "var(--bg)" }}>
    <Logo/>
    <div className="mt-6 flex items-center gap-2 text-sm text-zinc-500">
      <Loader2 size={13} className="animate-spin"/> Loading workspace…
    </div>
  </div>
);

export const ProtectedRoute = ({ children, roles }) => {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <Splash/>;
  if (!user) return <Navigate to="/auth" replace state={{ from: location }}/>;
  if (!user.role && location.pathname !== "/select-role") return <Navigate to="/select-role" replace/>;
  if (user.role && location.pathname === "/select-role") return <Navigate to={`/${user.role}`} replace/>;
  if (roles && !roles.includes(user.role)) return <Navigate to={`/${user.role}`} replace/>;
  // Enforce onboarding
  if (!user.onboarding_complete && user.role === "student" && !location.pathname.startsWith("/student/onboarding"))
    return <Navigate to="/student/onboarding" replace/>;
  if (!user.onboarding_complete && user.role === "company" && !location.pathname.startsWith("/company/onboarding"))
    return <Navigate to="/company/onboarding" replace/>;
  return children;
};

export default ProtectedRoute;
